import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { RamiComponent } from 'src/app/admin/rami/rami.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => RamoPickerComponent) },
  ],
  selector: 'ramo-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class RamoPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(RamiComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
